import { usdOnlyCardTypes } from "../constants";

export const isCardTypeValidForCurrency = (cardTypeName: string | undefined, currencyCode: string): boolean => {
  if (!cardTypeName) {
    return false;
  }

  const isUsdOnlyCardType = usdOnlyCardTypes.map((value) => value.toLowerCase()).includes(cardTypeName.toLowerCase());

  //valid unless the card type is USD-only and the currency isn't USD.
  return !isUsdOnlyCardType || currencyCode === "USD";
};
